export default __webpack_public_path__ + "static/media/AKM_5.4c7e293f.png";